import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { Input } from 'components/fields'
import { Form } from 'components/layout'
import { FormButton, Module } from 'components/misc'
import { form } from 'helpers/decorators'
import { AccessVerificationContext } from 'components/providers/AccessVerificationProvider'

@form({
  form: 'accessVerificationForm',
  disableHook: true,
  validate: values => {
    const errors = {}

    if (!values.verificationCode) {
      errors.verificationCode = 'Required'
    }
    return errors
  }
})
class AccessVerificationForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    verifyButtonDisabled: PropTypes.bool,
    sendButtonDisabled: PropTypes.bool.isRequired,
    resendMessage: PropTypes.any.isRequired
  }

  static contextType = AccessVerificationContext

  sendVerificationCodeToEmail = () => {
    this.context.sendVerificationCodeToEmail()
  }

  handleVerify = values => {
    const { verificationCode } = values

    this.context.verify(verificationCode)
  }

  render() {
    const { handleSubmit, verifyButtonDisabled, sendButtonDisabled, resendMessage } = this.props

    return (
      <Module>
        <Form onSubmit={handleSubmit(this.handleVerify)}>
          <h2 className="alpha nowrap">
            <FormattedMessage
              id="moduleTitle.access_verification"
              defaultMessage="Access verification"
            />
          </h2>

          <Input
            name="verificationCode"
            label="Verification code"
            intlKey="label.verification_code"
          />

          <FormButton
            simple
            fluid
            pristine={verifyButtonDisabled}
            style={{ marginBottom: '1rem' }}
          >
            <FormattedMessage id="button.verify" defaultMessage="Verify" />
          </FormButton>

          {resendMessage && (
            <p className="info-text">
              {resendMessage}
            </p>
          )}

          <FormButton
            type="button"
            simple
            fluid
            onClick={this.sendVerificationCodeToEmail}
            pristine={sendButtonDisabled}
          >
            <FormattedMessage id="button.send_code_email" defaultMessage="Send code to email" />
          </FormButton>
        </Form>
      </Module>
    )
  }
}

export default AccessVerificationForm
